import { ruleRunner, run } from 'app/utils/formValidation';

const nameValidation = value => {
  let errorMessage = 'Name cannot be empty.';
  const maxTextLength = 50;
  const textLength = value.length;

  if (textLength === 0) {
    return () => errorMessage;
  }

  if (value.length > maxTextLength) {
    errorMessage = `Name cannot be greater than 50 characters. (${
      maxTextLength - textLength
    })`;
    return () => errorMessage;
  }

  return null;
};

const descriptionValidation = value => {
  const maxTextLength = 130;
  const textLength = value.length;
  const errorMessage = `Description cannot be greater than 130 characters. (${
    maxTextLength - textLength
  })`;

  if (textLength > maxTextLength) {
    return () => errorMessage;
  }

  return null;
};

const fieldValidations = [
  ruleRunner('name', 'Name', nameValidation),
  ruleRunner('description', 'Description', descriptionValidation),
];

export const validator = values => {
  return run(values, fieldValidations);
};
